<script setup lang="ts">
/**
 * The page frame (UI consistency, packet 2): every in-app page sits inside
 * AppShell's own content padding at exactly one of two widths. FULL width —
 * lists, boards, calendars, detail pages, dashboards, tables — is the default
 * and needs no wrapper at all. FORM width — settings and form pages — is this
 * component with `width="form"`: a 48rem column, centred in the panel.
 *
 * It sets a width and nothing else. Padding stays the shell's; a view never
 * adds its own outer padding, `max-w-*` or negative margin (scripts/check-ds-page-frame.mjs).
 */
withDefaults(defineProps<{ width?: 'full' | 'form'; tag?: string }>(), { width: 'full', tag: 'div' });
</script>

<template>
  <component :is="tag" class="lumi-page-frame" :class="`lumi-page-frame--${width}`"><slot /></component>
</template>

<style>
.lumi-page-frame{width:100%;min-width:0;}
.lumi-page-frame--form{max-width:48rem;margin-inline:auto;}
</style>
